import { render, staticRenderFns } from "./SSelectOption.vue?vue&type=template&id=2be31e30&scoped=true&"
import script from "./SSelectOption.vue?vue&type=script&lang=ts&"
export * from "./SSelectOption.vue?vue&type=script&lang=ts&"
import style0 from "./SSelectOption.vue?vue&type=style&index=0&id=2be31e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be31e30",
  null
  
)

export default component.exports